/* ============================================================
   Case studies carousel — Swiper 11 (bundled per page)
   ------------------------------------------------------------
   Swiper is `import`ed from the npm ESM build, so esbuild bundles
   it straight into this page's JS — it only ships on pages whose
   entry imports this component (see case-studies.css / .case-studies-swiper).
   The ESM build is modular: register only the features we use
   (Navigation) so unused Swiper modules are tree-shaken out.
   ============================================================ */
import Swiper from "swiper";
import { Navigation, EffectFade, Mousewheel, Keyboard } from "swiper/modules";

export function initFeaturedCaseStudiesCarousel() {
  const el = document.querySelector(".case-studies-swiper");
  if (!el) return;

  const blurBgPicture = document.querySelector(".case-study-blur-bg");
  const blurBgImg = blurBgPicture?.querySelector("img");
  const blurBgSource = blurBgPicture?.querySelector("source");

  const updateBackground = (swiper) => {
    if (!blurBgPicture || !blurBgImg) return;

    const activeSlide = swiper.slides[swiper.activeIndex];
    if (!activeSlide) return;

    const activeImg = activeSlide.querySelector(".case-studies-media img");
    if (!activeImg) return;

    const newSrc = activeImg.currentSrc || activeImg.src;
    if (!newSrc) return;

    // Convert jpg/jpeg/png to webp
    const newWebp = newSrc.replace(/\.(jpe?g|png)$/i, ".webp");

    blurBgPicture.classList.add("is-changing");

    const preloadImage = new Image();

    preloadImage.onload = () => {
      if (blurBgSource) {
        blurBgSource.srcset = newWebp;
      }

      blurBgImg.src = newSrc;
      blurBgImg.alt = activeImg.alt || "";

      blurBgPicture.classList.remove("is-changing");
    };

    preloadImage.onerror = () => {
      // Keep the existing background if the image fails to load
      blurBgPicture.classList.remove("is-changing");
    };

    preloadImage.src = newSrc;
  };

  new Swiper(el, {
    modules: [Navigation, EffectFade, Mousewheel, Keyboard],
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    mousewheel: {
      forceToAxis: true,
      sensitivity: 1,
      releaseOnEdges: true,
    },
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
    slidesPerView: 1,
    spaceBetween: 20,
    loop: false,
    speed: 600,
    navigation: {
      prevEl: "[data-case-prev]",
      nextEl: "[data-case-next]",
    },

    on: {
      init(swiper) {
        updateBackground(swiper);
      },

      slideChangeTransitionStart(swiper) {
        updateBackground(swiper);
      },
    },
  });
}
